module.exports = __webpack_public_path__ + "static/media/Tournament Knight.31c07016.jpg";